import { Modal } from 'design-system';

interface ConfirmDialogProps {
  /**
   * 对话框标题
   */
  title?: string;
  /**
   * 对话框内容
   */
  content: string;
  /**
   * 确认按钮文字
   */
  okText?: string;
  /**
   * 取消按钮文字
   */
  cancelText?: string;
  /**
   * 点击确认按钮的回调函数
   */
  onOk?: () => void;
  /**
   * 点击取消按钮的回调函数
   */
  onCancel?: () => void;
}

/**
 * 显示确认对话框
 * @param props 对话框配置属性
 */
export const showConfirmDialog = ({
  title = '提示',
  content,
  okText = '确定',
  cancelText = '取消',
  onOk,
  onCancel,
}: ConfirmDialogProps) => Modal.confirm({
    title,
    content,
    okText,
    cancelText,
    onOk,
    onCancel,
    okButtonProps: {
      style: {
        backgroundColor: '#105FC8',
        borderColor: '#105FC8'
      }
    }
  });

/**
 * 显示未保存数据离开确认对话框
 * @param onOk 确认离开回调
 * @param onCancel 取消离开回调
 */
export const showUnsavedDataConfirm = (onOk?: () => void, onCancel?: () => void) => showConfirmDialog({
    title: '提示',
    content: '你有未保存的数据，确定离开吗？',
    okText: '确定',
    cancelText: '取消',
    onOk,
    onCancel,
  });

// 导出 Modal 以便其他组件可以继续使用 Modal
export { Modal };